/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';

import {
  ChecklistWrapper,
  Container,
  ContentWrapper,
  GridContainer,
  SectionTitle,
  SectionWrapper,
} from './styles';

import { MuiInput } from '../../components/Material/MuiInput';
import { SubmitHandler, useForm } from 'react-hook-form';

import Select from '../../components/Material/Select';
import { TipoCarreta, TipoCarretaValueEnum } from '../../constants/veiculos';
import { MuiCheckbox } from '../../components/Material/Checkbox';
import { ChecklistDataVhp } from '../../constants/checklist-vhp';
import { Printers } from '../../constants/printers';
import { CircularProgress, useTheme } from '@mui/material';
import {
  FormDataVhp,
  IAgendamentoEtanolChecklist,
} from '../../types/checklist';
import api from '../../services/api';
import { shouldApproveVhpChecklist } from '../../utils/shouldApproveChecklist';
import moment from 'moment';
import CustomLoadingButton from '../../components/Material/CustomLoadingButton';
import { FiCheckSquare } from 'react-icons/fi';
import { VhpChecklistReport } from '../../components/Reports/VhpChecklistReport';
import { ChecklistImageUploader } from '../../components/ChecklistImages/ChecklistImageUploader';
import { useChecklistImages } from '../../hooks/useChecklistImages';
import {
  toChecklistReportImages,
  waitForImagesToLoad,
} from '../../utils/checklistImages';

interface IChecklistVhpProps {
  isValid?: boolean;
}

const ChecklistVhp = React.forwardRef<
  HTMLInputElement,
  IChecklistVhpProps
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
>(({ isValid }, ref) => {
  const { addToast } = useToast();
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const theme = useTheme();
  const location = useLocation();

  const params = location.state.params;

  const [loading, setLoading] = useState(false);
  const [loadingPost, setLoadingPost] = useState(false);
  const [checklist, setChecklist] = useState<any>();
  const [reportData, setReportData] = useState<any>(null);

  const { images, setImages, clearImages } = useChecklistImages();

  const minWidthMuiInput = '400px';
  const maxWidthMuiInput = '400px';

  const paramsToAgendamentoData = {
    agendamentoid: params.agendamentoid,
    spot: params.spot,
    data: params.data,
    produto: params.produto,
    pedido: params.pedido,
    motoristaid: params.agendamentoData.motoristaid,
    cpfmotorista: params.cpf,
    nome: params.motorista,
    cnpj: params.agendamentoData.cnpj,
    placa: params.placa,
    placa2: params.placa2,
    volume: params.agendamentoData.volume,
    volume2: params.agendamentoData.volume2,
    volumetotal: params.agendamentoData.volumetotal,
    volumeordem: params.agendamentoData.volumeordem,
    status: params.agendamentoData.status,
    placacavalo: params.agendamentoData.placacavalo,
    fa: params.agendamentoData.fa,
    pedido2: params.agendamentoData.pedido2,
  };

  useEffect(() => {
    const handleAfterPrint = () => {
      setLoadingPost(false);
      navigate(-1);
    };

    window.addEventListener('afterprint', handleAfterPrint);

    return () => {
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, []);

  useEffect(() => {
    async function loadChecklist(): Promise<void> {
      if (paramsToAgendamentoData.agendamentoid && checklist === undefined) {
        setLoading(true);
        await api
          .get(
            `/checklist/vhp/byagendamentoid/${Number(
              paramsToAgendamentoData.agendamentoid,
            )}`,
          )
          .then(response => {
            if (response.data === null) {
              setChecklist([]);
              setLoading(false);
              return;
            }

            setChecklist(response.data);
            setLoading(false);
          })
          .catch(error => {
            console.log('error loading checklist etanol', error);
          });
      }
    }
    loadChecklist();
  }, [paramsToAgendamentoData]);

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<FormDataVhp>();

  useEffect(() => {
    if (params.agendamentoData) {
      (
        Object.keys(
          paramsToAgendamentoData,
        ) as (keyof IAgendamentoEtanolChecklist)[]
      ).forEach(key => {
        setValue(key as keyof FormDataVhp, paramsToAgendamentoData[key]);
      });
    }
  }, [params.agendamentoData, setValue]);

  const createReportData = (data: FormDataVhp) => ({
    ...data,
    images: toChecklistReportImages(images),
  });

  const onSubmit: SubmitHandler<FormDataVhp> = async (data: FormDataVhp) => {
    try {
      if (data.tipocarreta === '') {
        addToast({
          type: 'error',
          title: 'Checklist',
          description: 'Tipo carreta é obrigatório',
        });
        return;
      }

      if (
        data.volumeordem === undefined ||
        data.volumeordem === null ||
        data.volumeordem === ''
      ) {
        addToast({
          type: 'error',
          title: 'Checklist',
          description: 'Volume Ordem é obrigatório',
        });
        return;
      }

      const formattedDate = moment().format('YYYY-MM-DD HH:mm:ss');

      setReportData(createReportData(data));

      // Update Checklist
      if (
        checklist &&
        Number(checklist.agendamentoid) === Number(data.agendamentoid)
      ) {
        setLoadingPost(true);

        await api
          .put(`/checklist/vhp/${checklist.agendamentoid}`, {
            agendamentoid: data.agendamentoid,
            spot: data.spot,
            data: formattedDate,
            produto: 'VHP',
            pedido: data.pedido,
            motorista: data.nome,
            cpfmotorista: data.cpfmotorista,
            cnpj: data.cnpj,
            placa: data.placa,
            placa2: data.placa2,
            volume: data.volume,
            volume2: data.volume2,
            volumetotal: data.volumetotal,
            volumeordem: data.volumeordem,
            status: data.status,
            placacavalo: data.placacavalo,
            fa: data.fa,
            pedido2: data.pedido2,
            tipocarreta: data.tipocarreta,
            dnit: data.dnit,
            cnh: data.cnh,
            epis: data.epis,
            roupasapropriadas: data.roupasApropriadas,
            acompanhantes: data.acompanhantes,
            alertavazamentos: data.alertaVazamentos,
            alertaalimentacao: data.alertaAlimentacao,
            alertasomalto: data.alertaSomAlto,
            parachoques: data.paraChoques,
            placasdanificadas: data.placasDanificadas,
            faroisdanificados: data.faroisDanificados,
            lanternassetasdanificadas: data.lanternasSetasDanificadas,
            extintorincendio: data.extintorIncendio,
            vazamentocombustivel: data.vazamentoCombustivel,
            fitasrefletivas: data.fitasRefletivas,
            pneusbomestado: data.pneusBomEstado,
            galoes: data.galoes,
            buracos: data.buracos,
            odorestranho: data.odorEstranho,
            presencapragas: data.presencaPragas,
            residuocarga: data.residuoCarga,
            umidade: data.umidade,
            limpo: data.limpo,
            lonacomresiduos: data.lonaComResiduos,
            lonadanificada: data.lonaDanificada,
            lonalimpa: data.lonaLimpa,
            lonaseca: data.lonaSeca,
            lonaodorestranho: data.lonaOdorEstranho,
            lonapresencapragas: data.lonaPresencaPragas,
            lonaresiduocarga: data.lonaResiduoCarga,
            checklistaprovado: false,
            lacres: data.lacres,
            observacoes: data.observacoes,
          })

          .then(() => {
            addToast({
              type: 'success',
              title: 'Checklist',
              description: 'Checklist atualizado com sucesso',
            });

            return;
          })
          .catch(error => {
            console.log('error atualizar checklist', error);
            addToast({
              type: 'error',
              title: 'Checklist',
              description: 'Erro ao atualizar checklist',
            });
            setLoadingPost(false);
          });
      } else {
        // Create Checklist
        setLoadingPost(true);
        await api
          .post('/checklist/vhp', {
            agendamentoid: data.agendamentoid,
            spot: data.spot,
            data: formattedDate,
            produto: 'VHP',
            pedido: data.pedido,
            motorista: data.nome,
            cpfmotorista: data.cpfmotorista,
            cnpj: data.cnpj,
            placa: data.placa,
            placa2: data.placa2,
            volume: data.volume,
            volume2: data.volume2,
            volumetotal: data.volumetotal,
            volumeordem: data.volumeordem,
            status: data.status,
            placacavalo: data.placacavalo,
            fa: data.fa,
            pedido2: data.pedido2,
            tipocarreta: data.tipocarreta,
            dnit: data.dnit,
            cnh: data.cnh,
            epis: data.epis,
            roupasapropriadas: data.roupasApropriadas,
            acompanhantes: data.acompanhantes,
            alertavazamentos: data.alertaVazamentos,
            alertaalimentacao: data.alertaAlimentacao,
            alertasomalto: data.alertaSomAlto,
            parachoques: data.paraChoques,
            placasdanificadas: data.placasDanificadas,
            faroisdanificados: data.faroisDanificados,
            lanternassetasdanificadas: data.lanternasSetasDanificadas,
            extintorincendio: data.extintorIncendio,
            vazamentocombustivel: data.vazamentoCombustivel,
            fitasrefletivas: data.fitasRefletivas,
            pneusbomestado: data.pneusBomEstado,
            galoes: data.galoes,
            buracos: data.buracos,
            odorestranho: data.odorEstranho,
            presencapragas: data.presencaPragas,
            residuocarga: data.residuoCarga,
            umidade: data.umidade,
            limpo: data.limpo,
            lonacomresiduos: data.lonaComResiduos,
            lonadanificada: data.lonaDanificada,
            lonalimpa: data.lonaLimpa,
            lonaseca: data.lonaSeca,
            lonaodorestranho: data.lonaOdorEstranho,
            lonapresencapragas: data.lonaPresencaPragas,
            lonaresiduocarga: data.lonaResiduoCarga,
            checklistaprovado: false,
            lacres: data.lacres,
            observacoes: data.observacoes,
          })
          .catch(error => {
            console.log('error salvar checklist-', error);

            addToast({
              type: 'error',
              title: 'Checklist',
              description: 'Erro ao salvar checklist',
            });
            setLoadingPost(false);
          });
      }

      // Approve checklist
      if (shouldApproveVhpChecklist(data)) {
        setLoadingPost(true);

        const dataWithChecklistApproved = {
          ...data,
          data: formattedDate,
          motorista: data.nome,
          checklistaprovado: true,
        };

        await api.put(
          `/checklist/vhp/${checklist.agendamentoid}`,
          dataWithChecklistApproved,
        );

        await api
          .post('/fila/checklist', {
            data: data.data,
            cpf: data.cpfmotorista,
            pedido: Number(data.pedido),
            volumeordem: Number(data.volumeordem),
            tipocarreta: TipoCarretaValueEnum[data.tipocarreta],
            dnit: data.dnit,
            lacres: data.lacres,
            agendamentoid: data.agendamentoid,
            printerName: data.printer,
          })
          .then(async () => {
            setReportData(createReportData(data));

            addToast({
              type: 'success',
              title: 'Checklist',
              description: 'Checklist aprovado com sucesso',
              timeout: 1500,
            });

            // setTimeout(() => {
            //   // navigate(-1);
            //   window.print();
            // }, 3000);

            const printableReportData = createReportData(data);

            setReportData(printableReportData);

            await waitForImagesToLoad(
              printableReportData.images.map(image => image.url),
            );

            // Allows React to render the report before opening the print dialog.
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                window.print();
              });
            });

            clearImages();

            return;
          })
          .catch(error => {
            console.log('error aprova checklist-', error.response.data.message);

            addToast({
              type: 'success',
              title: 'Checklist erro',
              description: `Erro ao aprovar checklist, informar ao TI - ${error.response.data.message}`,
            });
            setLoadingPost(false);

            setTimeout(() => {
              navigate(-1);
            }, 3000);
          });
      } else {
        setTimeout(() => {
          navigate(-1);
        }, 3000);
      }
    } catch (err: any) {
      // Close the modal

      console.log('error checklist, err');
      // Show Toast for failure
      addToast({
        type: 'error',
        title: 'Erro atualizar/criar checklist.',
        description: `${err.response.data.message}`,
      });
      setLoadingPost(false);
    }
  };

  return (
    <>
      <Container>
        <header>
          <h1>Bom Sucesso Agroindústria S.A</h1>

          <nav>
            <button type="submit" onClick={() => navigate('/')}>
              Página Inicial
            </button>

            <button type="submit" onClick={() => navigate(-1)}>
              Voltar
            </button>

            <button type="submit" onClick={signOut}>
              Logout
            </button>
          </nav>
        </header>

        <h1
          style={{
            textAlign: 'center',
            color: theme.palette.primary.main,
            marginTop: '40px',
          }}
        >
          Checklist VHP
        </h1>

        <div
          style={{
            borderBottom: `2px solid ${theme.palette.neutral.midGrey}`,
            height: '1px',
            width: '600px',
            justifySelf: 'center',
            marginTop: '16px',
          }}
        ></div>

        <ContentWrapper>
          {loading ? (
            <div
              style={{
                display: 'flex',
                width: '100%',
                height: '200px',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CircularProgress sx={{ color: '#00a859' }} />
            </div>
          ) : (
            <ChecklistWrapper>
              <form
                onSubmit={handleSubmit(onSubmit)}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                {/* 1 - Agendamento */}
                <SectionWrapper>
                  <SectionTitle>1 - Agendamento</SectionTitle>
                  <GridContainer size={420} columns={3}>
                    <MuiInput
                      {...register('agendamentoid')}
                      name="agendamentoid"
                      label="Agendamento ID"
                      control={control}
                      error={Boolean(errors.agendamentoid)}
                      defaultValue={params.agendamentoid}
                      disabled
                      ref={ref}
                      minWidth={minWidthMuiInput}
                      maxWidth={maxWidthMuiInput}
                    />

                    <MuiInput
                      {...register('produto')}
                      name="produto"
                      label="Produto"
                      control={control}
                      error={Boolean(errors.produto)}
                      defaultValue={params.produto}
                      disabled
                      ref={ref}
                      minWidth={minWidthMuiInput}
                      maxWidth={maxWidthMuiInput}
                    />

                    <MuiInput
                      {...register('spot')}
                      name="spot"
                      label="Spot"
                      control={control}
                      error={Boolean(errors.spot)}
                      defaultValue={params.spot}
                      disabled
                      ref={ref}
                      minWidth={minWidthMuiInput}
                      maxWidth={maxWidthMuiInput}
                    />

                    <MuiInput
                      {...register('data')}
                      name="data"
                      label="Data"
                      control={control}
                      error={Boolean(errors.data)}
                      defaultValue={params.data}
                      disabled
                      ref={ref}
                      minWidth={minWidthMuiInput}
                      maxWidth={maxWidthMuiInput}
                    />

                    <MuiInput
                      {...register('cnpj')}
                      name="cnpj"
                      label="CNPJ Transportadora"
                      control={control}
                      error={Boolean(errors.cnpj)}
                      defaultValue={params.agendamentoData.cnpj}
                      disabled
                      ref={ref}
                      minWidth={minWidthMuiInput}
                      maxWidth={maxWidthMuiInput}
                    />

                    <MuiInput
                      {...register('nome')}
                      name="nome"
                      label="Motorista"
                      control={control}
                      error={Boolean(errors.nome)}
                      defaultValue={params.nome}
                      disabled
                      ref={ref}
                      minWidth={minWidthMuiInput}
                      maxWidth={maxWidthMuiInput}
                    />

                    <MuiInput
                      {...register('cpfmotorista')}
                      name="cpfmotorista"
                      label="CPF"
                      control={control}
                      error={Boolean(errors.cpfmotorista)}
                      defaultValue={params.cpf}
                      disabled
                      ref={ref}
                      minWidth={minWidthMuiInput}
                      maxWidth={maxWidthMuiInput}
                    />

                    <MuiInput
                      {...register('placacavalo')}
                      name="placacavalo"
                      label="Cavalo"
                      control={control}
                      error={Boolean(errors.placacavalo)}
                      defaultValue={params.agendamentoData.placacavalo}
                      disabled
                      ref={ref}
                      minWidth={minWidthMuiInput}
                      maxWidth={maxWidthMuiInput}
                    />

                    <MuiInput
                      {...register('placa')}
                      name="placa"
                      label="Placa"
                      control={control}
                      error={Boolean(errors.placa)}
                      defaultValue={params.placa}
                      disabled
                      ref={ref}
                      minWidth={minWidthMuiInput}
                      maxWidth={maxWidthMuiInput}
                    />

                    <MuiInput
                      {...register('placa2')}
                      name="placa2"
                      label="Placa 2"
                      control={control}
                      error={Boolean(errors.placa2)}
                      defaultValue={params.placa2}
                      disabled
                      ref={ref}
                      minWidth={minWidthMuiInput}
                      maxWidth={maxWidthMuiInput}
                    />

                    <MuiInput
                      {...register('volume')}
                      name="volume"
                      label="Volume"
                      control={control}
                      error={Boolean(errors.volume)}
                      defaultValue={params.volume}
                      disabled
                      ref={ref}
                      minWidth={minWidthMuiInput}
                      maxWidth={maxWidthMuiInput}
                    />

                    <MuiInput
                      {...register('volume2')}
                      name="volume2"
                      label="Volume 2"
                      control={control}
                      error={Boolean(errors.volume2)}
                      defaultValue={params.agendamentoData?.volume2}
                      disabled
                      ref={ref}
                      minWidth={minWidthMuiInput}
                      maxWidth={maxWidthMuiInput}
                    />

                    <MuiInput
                      {...register('volumetotal')}
                      name="volumetotal"
                      label="Volume Total"
                      control={control}
                      error={Boolean(errors.volumetotal)}
                      defaultValue={params.agendamentoData?.volumetotal}
                      disabled
                      ref={ref}
                      minWidth={minWidthMuiInput}
                      maxWidth={maxWidthMuiInput}
                    />

                    <div
                      style={{
                        marginTop: '-16px',
                        height: '56px',
                      }}
                    >
                      <MuiInput
                        {...register('volumeordem', {
                          required: 'Volume obrigatório.',
                        })}
                        name="volumeordem"
                        label="Volume Ordem"
                        control={control}
                        error={Boolean(errors.volumeordem)}
                        defaultValue={params.agendamentoData?.volumeordem}
                        ref={ref}
                        minWidth={minWidthMuiInput}
                        maxWidth={maxWidthMuiInput}
                      />
                    </div>

                    <div
                      style={{
                        marginTop: '16px',
                        height: '56px',
                      }}
                    >
                      <Select
                        {...register('tipocarreta', {
                          required: 'Tipo carreta obrigatório',
                        })}
                        name="tipocarreta"
                        label="Tipo Carreta"
                        control={control}
                        options={TipoCarreta}
                        variant="outlined"
                        minWidth={minWidthMuiInput}
                        maxWidth={maxWidthMuiInput}
                      />
                    </div>
                  </GridContainer>
                </SectionWrapper>

                {/* 2 - Documentacao */}
                <SectionWrapper>
                  <SectionTitle>2 - Documentação</SectionTitle>
                  <GridContainer size={420} columns={3}>
                    {ChecklistDataVhp.Documentacao.map(doc => (
                      <MuiCheckbox
                        key={doc.id}
                        name={doc.name}
                        label={`${doc.id} - ${doc.label}`}
                        control={control}
                      />
                    ))}
                  </GridContainer>
                </SectionWrapper>

                {/* 3 - Motorista */}
                <SectionWrapper>
                  <SectionTitle>3 - Motorista</SectionTitle>
                  <GridContainer size={420} columns={3} rowgap={'16px'}>
                    {ChecklistDataVhp.Motorista.map(mot => (
                      <MuiCheckbox
                        key={mot.id}
                        name={mot.name}
                        label={`${mot.id} - ${mot.label}`}
                        control={control}
                      />
                    ))}
                  </GridContainer>
                </SectionWrapper>

                {/* 4 - Veículo */}
                <SectionWrapper>
                  <SectionTitle>4 - Veículo</SectionTitle>
                  <GridContainer size={420} columns={3} rowgap={'16px'}>
                    {ChecklistDataVhp.Veiculo.map(veiculo => (
                      <MuiCheckbox
                        key={veiculo.id}
                        name={veiculo.name}
                        label={`${veiculo.id} - ${veiculo.label}`}
                        control={control}
                      />
                    ))}
                  </GridContainer>
                </SectionWrapper>

                {/* 5 - Cacamba / Carroceria */}
                <SectionWrapper>
                  <SectionTitle>5 - Caçamba/Carroceria</SectionTitle>
                  <GridContainer size={420} columns={3} rowgap={'16px'}>
                    {ChecklistDataVhp.CacambaCarroceria.map(elet => (
                      <MuiCheckbox
                        key={elet.id}
                        name={elet.name}
                        label={`${elet.id} - ${elet.label}`}
                        control={control}
                      />
                    ))}
                  </GridContainer>
                </SectionWrapper>

                {/* 6 - Lona */}
                <SectionWrapper>
                  <SectionTitle>6 - Lona</SectionTitle>
                  <GridContainer size={420} columns={3} rowgap={'16px'}>
                    {ChecklistDataVhp.Lona.map(aterr => (
                      <MuiCheckbox
                        key={aterr.id}
                        name={aterr.name}
                        label={`${aterr.id} - ${aterr.label}`}
                        control={control}
                      />
                    ))}
                  </GridContainer>
                </SectionWrapper>

                {/* 7 - Imagens */}
                <SectionWrapper>
                  <SectionTitle>7 - Imagens</SectionTitle>
                  <GridContainer size={1236} columns={1} columngap="16px">
                    <ChecklistImageUploader
                      images={images}
                      onChange={setImages}
                      maxImages={10}
                      maxFileSizeMb={10}
                      disabled={loadingPost}
                      onValidationError={message => {
                        addToast({
                          type: 'error',
                          title: 'Imagens',
                          description: message,
                        });
                      }}
                    />
                  </GridContainer>
                </SectionWrapper>

                {/* 8 - Outros */}
                <SectionWrapper>
                  <SectionTitle>8 - Outros</SectionTitle>
                  <GridContainer size={420} columns={3}>
                    <MuiInput
                      {...register('lacres')}
                      name="lacres"
                      label="Lacres"
                      control={control}
                      error={Boolean(errors.lacres)}
                      defaultValue={''}
                      minWidth={minWidthMuiInput}
                      maxWidth={maxWidthMuiInput}
                      ref={ref}
                    />

                    <MuiInput
                      {...register('observacoes')}
                      name="observacoes"
                      label="Observacoes"
                      control={control}
                      error={Boolean(errors.observacoes)}
                      defaultValue={''}
                      minWidth={minWidthMuiInput}
                      maxWidth={maxWidthMuiInput}
                      ref={ref}
                    />

                    <div
                      style={{
                        width: '300px',
                        marginTop: '16px',
                        height: '56px',
                      }}
                    >
                      <Select
                        {...register('printer', {
                          required: 'Impressora obrigatória',
                        })}
                        name="printer"
                        label="Impressora"
                        control={control}
                        options={Printers}
                        variant="outlined"
                        minWidth={minWidthMuiInput}
                        maxWidth={maxWidthMuiInput}
                      />
                    </div>

                    {ChecklistDataVhp.Outros.map(outros => (
                      <MuiInput
                        key={outros.name}
                        name={outros.name}
                        label={outros.label}
                        control={control}
                        defaultValue={
                          params.agendamentoData?.[outros.name] || ''
                        }
                        minWidth={minWidthMuiInput}
                        maxWidth={maxWidthMuiInput}
                      />
                    ))}
                  </GridContainer>
                </SectionWrapper>

                <div style={{ marginTop: '72px', marginBottom: '16px' }}>
                  <CustomLoadingButton
                    text="Salvar"
                    icon={<FiCheckSquare size={24} />}
                    loading={loadingPost}
                    type="submit"
                    customStyles={{
                      ':hover': { backgroundColor: '#33bc83' },
                      color: theme.palette.neutral.white,
                      fontWeight: '600',
                      fontSize: '22px',
                      background: theme.palette.primary.main,
                      width: '200px',
                      height: '48px',
                      borderRadius: '16px',
                    }}
                  />
                </div>
              </form>
            </ChecklistWrapper>
          )}
        </ContentWrapper>
      </Container>
      {reportData && <VhpChecklistReport reportData={reportData} />}
    </>
  );
});

ChecklistVhp.displayName = 'ChecklistVhp';

export default ChecklistVhp;
